import { render, staticRenderFns } from "./attribute-promotion.vue?vue&type=template&id=b569d112&functional=true"
import script from "./attribute-promotion.vue?vue&type=script&lang=js"
export * from "./attribute-promotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports